import { LoanPeriod } from "../../../../../../constants/Constants";

export const TecAssuredVehicleInputMap = {
	DLP: {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term In Months",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "new.used",
				Name: "NEW/USED",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Vehicle Purchase Price",
				DC: "deal.sale.price",
			},
		],
		21: [
			{
				Property: "serial",
				Name: "Serial Number",
				DC: "vehicle.vin",
			},
			{
				Property: "inServiceDate",
				Name: "In Service Date",
				DC: "vehicle.createdOn",
			},
			{
				Property: "manufacturer",
				Name: "Manufacturer",
				DC: "vehicle.make",
			},
			{
				Property: "model",
				Name: "Model",
				DC: "vehicle.model",
			},
			{
				Property: "modelYear",
				Name: "Model Year",
				DC: "vehicle.year",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Vehicle Purchase Price",
				DC: "deal.sale.price",
			},
		],
	},
	RS: {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term In Months(Gap)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "inServiceDate",
				Name: "In-Service Date",
				DC: "vehicle.createdOn",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
		],
		7: [
			{
				Property: "serial",
				Name: "Serial Number",
				DC: "vehicle.vin",
			},
			{
				Property: "amountFinanced",
				Name: "Amount Financed",
				DC: "deal.sale.amtFinanced",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term (months)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "manufacturer",
				Name: "Manufacturer (i.e.FLEETWOOD)",
				DC: "vehicle.make",
			},
			{
				Property: "model",
				Name: "Model  (i.e.C47-FLAIR)",
				DC: "vehicle.model",
			},
			{
				Property: "modelYear",
				Name: "Model Year",
				DC: "vehicle.year",
			},
			{
				Property: "msrp-nada",
				Name: "MSRP/NADA",
				DC: "vehicle.acv",
			},
			{
				Property: "new-used",
				Name: "NEW/USED",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
		],
		21: [
			{
				Property: "serial",
				Name: "Serial Number",
				DC: "vehicle.vin",
			},
		],
	},
	"IMA TPA": {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term Months(Gap)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "new.used",
				Name: "New/Used",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
		],
	},
	"Diamond Warranty": {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term In Months(Gap)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "loanAmount",
				Name: "Amount Financed",
				DC: "deal.sale.amtFinanced",
			},
			// We do not track whether a vehicle has a factory warranty
			// {
			// 	Property: "factoryWarranty",
			// 	Name: "Factory Warranty",
			// 	DC: "",
			// 	"Extension": {
			// 	  "Values": [
			// 		{
			// 		  "Key": null,
			// 		  "Value": "Select"
			// 		},
			// 		{
			// 		  "Key": "N",
			// 		  "Value": "No"
			// 		},
			// 		{
			// 		  "Key": "Y",
			// 		  "Value": "Yes"
			// 		}
			// 	  ]
			// 	}
			//   },
			{
				Property: "msrp-nada",
				Name: "MSRP/NADA",
				DC: "vehicle.msrp",
			},
			{
				Property: "transmissionType",
				Name: "Transmission Type",
				DC: "vehicle.transmission",
				transform: (transmission) => {
					const test = "test";
					test.toLowerCase().includes("auto");
					if (transmission.toLowerCase().includes("auto")) {
						return "Automatic";
					} else if (transmission.includes("4")) {
						return "Manual 4-Speed";
					} else if (transmission.includes("5")) {
						return "Manual 5-Speed";
					} else if (transmission.includes("6")) {
						return "Manual 6-Speed";
					} else if (transmission.toUpperCase().includes("CVT")) {
						return "CVT";
					}
				},
			},
			{
				Property: "N-U",
				Name: "NEW-USED?",
				DC: "vehicle.newUsed",
				// transform: (value) => value?.toUpperCase?.(),
			},
		],
	},
	HeadStart: {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term Months(Gap)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "N-U",
				Name: "New or Used",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
		],
	},
};

export const getValueByPath = (obj, path) => {
	if (!obj || !path) return undefined;
	return path
		.split(".")
		.reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
};

export const getFinanceTermInMonths = (term, dealObj) => {
	const periodValue = dealObj.deal.sale?.loanPeriod;
	const rawTerm = Number(term);
	if (!rawTerm || typeof periodValue !== "number") return undefined;
	const period = LoanPeriod.find((p) => p.value === periodValue);
	if (!period || !period.term) return undefined;
	const months = Math.round((rawTerm / period.term) * 12);

	return months;
};
